import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  PropertySpaceFilterState,
  PropertySpaceRange,
} from '@immosky/types';
import { Subscription } from 'rxjs';
import {
  resetPropertySpaceFilter,
  selectPropertySpaceFilterState,
  setPropertySpaceFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-property-space-filter-dropdown',
  templateUrl: './property-space-filter-dropdown.component.html',
  styleUrls: ['./property-space-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertySpaceFilterDropdownComponent implements OnDestroy {
  private subscription: Subscription;

  appliedFilter!: PropertySpaceRange;
  currentFilter!: PropertySpaceRange;
  isActive = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.subscription = this.store
      .pipe(select(selectPropertySpaceFilterState))
      .subscribe((filterState: PropertySpaceFilterState) => {
        this.appliedFilter = {
          ...filterState.filter,
        };
        this.currentFilter = {
          ...filterState.filter,
        };
        this.isActive = filterState.isActive;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  select(filter: PropertySpaceRange) {
    this.currentFilter = filter;
  }

  applyChanges() {
    this.store.dispatch(
      setPropertySpaceFilter({
        filter: this.currentFilter,
      })
    );
  }

  reset() {
    this.store.dispatch(resetPropertySpaceFilter());
  }
}
